import { Injectable } from '@angular/core'
import { LocalStorageService } from '../utils/local-storage.service'
import { fromPromise } from 'rxjs/internal-compatibility'
import { catchError, first, retryWhen, switchMap, timeout } from 'rxjs/operators'
import { Observable, of, throwError } from 'rxjs'
import { ConfigService } from '../config.service'
import { LbHttpService } from '../lb-http.service'
import { HttpClient } from '@angular/common/http'
import { ErrorService } from '../utils/error.service'

@Injectable({
  providedIn: 'root'
})
export class QueueConfigService {

  public queueVersion = {}

  public appointmentsType = {}

  constructor(
      private http: HttpClient,
      private localStorageService: LocalStorageService,
      private configService: ConfigService,
      private lbHttpService: LbHttpService,
      private errorService: ErrorService
  ) { }

  public getQueueVersion( queueId ) {
    if ( queueId ) {
      if ( this.queueVersion && this.queueVersion[ queueId ] ) {
        return of( this.queueVersion[ queueId ] )
      } else {
        return this.httpGetQueueVersion( queueId ).pipe(
            switchMap( (versions) => {
              if ( versions && versions[ queueId ] ) {
                this.queueVersion[ queueId ] = versions[ queueId ]
                return of( versions[ queueId ] )
              }
            })
        )
      }
    } else {
      return of( null )
    }
  }


  public getAppointmentOfNextQueue( queueId ) {

    if ( queueId ) {
      if ( this.appointmentsType && this.appointmentsType[ queueId ] ) {
        return of( this.appointmentsType[ queueId ] )
      } else {
        return this.httpGetNextAppointment( queueId ).pipe(
            switchMap( (appointmentType) => {
              if ( appointmentType ) {
                this.appointmentsType[ queueId ] = appointmentType
                return of( appointmentType )
              }
            })
        )
      }
    } else {
      return of( null )
    }
  }

  private httpGetNextAppointment( queueId ) {
    let url = this.configService.getNextQueueAppointmentType
    url = url.replace( '{queueId}', queueId )

    return fromPromise( this.lbHttpService.generateHeaderForLineberty( false, false, 'booking' ) ).pipe(
        timeout(this.configService.defaultHttpTimeout),
        switchMap(  ( httpOptions: any ) => {
          return this.http.get(url, httpOptions)
        }),
        first(),
        retryWhen( this.lbHttpService.genericRetryStrategy( {} ) ),
        catchError( (error) => {
          this.errorService.logError('Error while getting next app type of queue', error)
          return throwError( error )
        })
    )
  }

  private httpGetQueueVersion( queueId ) {
    let url = this.configService.getQueueVersion
    url = url.replace( '{queueId}', queueId )

    return fromPromise( this.lbHttpService.generateHeaderForLineberty( false, false, 'booking' ) ).pipe(
        timeout(this.configService.defaultHttpTimeout),
        switchMap(  ( httpOptions: any ) => {
          httpOptions['params']['queuesId'] = [ queueId ]
          return this.http.get(url, httpOptions)
        }),
        first(),
        retryWhen( this.lbHttpService.genericRetryStrategy( {} ) ),
        catchError( (error) => {
          this.errorService.logError('Error while getting queue version', error)
          return throwError( error )
        })
    )
  }

  queueHaveMultipleAppointmentType ( queueAppointmentTypes? ) {

    if ( !queueAppointmentTypes ) {
      queueAppointmentTypes = this.localStorageService.getSelectedQueue().appointmentTypes
    }

    if ( queueAppointmentTypes && Object.keys( queueAppointmentTypes ).length > 1 ) {
      return true
    } else {
      return false
    }
  }

  queueHaveMultipleGroupSize ( queueConfig? ) {

    if ( !queueConfig ) {
      const queueId = this.localStorageService.getSelectedQueue().queueId
      const queue = this.localStorageService.getSelectedQueuesBooking( queueId )
      if (queue) queueConfig = queue.config
    }

    if ( queueConfig && queueConfig.groupSizeLimit && queueConfig.groupSizeLimit.min === queueConfig.groupSizeLimit.max ) {
      return false
    } else {
      return true
    }
  }

  queueBookingIsNextTimeslot( queueConfig? ): boolean {

    if ( !queueConfig ) {
      queueConfig = this.localStorageService.getSelectedQueue().config
    }

    if ( queueConfig && queueConfig.bookingType === 'FIRST_AVAILABLE_TIMESLOT' ) {
      return true
    } else {
      return false
    }
  }

  queueBookingIsMixed( queueConfig? ): boolean {

    if ( !queueConfig ) {
      queueConfig = this.localStorageService.getSelectedQueue().config
    }

    if ( queueConfig && queueConfig.bookingType === 'MIXED' ) {
      return true
    } else {
      return false
    }
  }
}
